import { FormattedOption } from 'types/dictionaries';

import { JobStatus } from 'constants/enums';

export const filterOutInReviewJobStatusOptions = (
  options: FormattedOption[]
): FormattedOption[] =>
  options.filter((option) => option.value !== JobStatus.InReview);

